/**
 * Checks whether a feature is enabled or not by looking for a class on the HTML tag
 * (similar to Modernizr). Used for CSS/JavaScript based feature switching.
 * @class
 */
function FeatureService() {
    const classes = document.documentElement.className.split(/\s+/);
    this._features = {};

    for (let i = 0; i < classes.length; i++) {
        this._features[classes[i]] = true;
    }
}

FeatureService.prototype.isEnabled = function (featureName) {
    return featureName in this._features && this._features[featureName];
};

FeatureService.prototype.setFeature = function (featureName, isEnabled) {
    this._features[featureName] = isEnabled;
};

/* STOP ADDING THINGS TO THIS, USE THE SETTINGS SERVICE! :) */
FeatureService.prototype.features = {
    responsive: 'responsive',
    onesiteProductStamp: 'onesiteproductstamp',
    fixedHeader: 'fixed-header',
    globalHeader: 'global-header',
    visualShopping: 'visual-shopping',
    smallFormat: 'small-format',
    collectionZone: 'collection-zone',
    checkout: 'conversational-checkout-wizard',
    sfExpandPersonalShopperComment: 'sf-expand-personal-shopper-comment',
    mfExpandPersonalShopperComment: 'mf-expand-personal-shopper-comment',
    lfExpandPersonalShopperComment: 'lf-expand-personal-shopper-comment',
    visualShoppingV2: 'visual-shopping-v2',
    centerPanelSlide: 'center-panel-slide',
    checkoutPerformanceEnhancements: 'checkout-performance-enhancements',
    centerProductTag: 'center-product-tag',
    pageTransitionAnimations: 'page-transition-animations',
    visualShoppingAisleRibbon: 'visual-shopping-aisle-ribbon',
    pricePoint: 'price-point',
    visualShoppingAisleIcons: 'visual-shopping-aisle-icons',
    clickAndCollectStoreSearch: 'click-and-collect-store-search',
    enableDiscoverLandingPage: 'enable-discover-landing-page',
    enableSpecialTypeLandingPage: 'enable-special-type-landing-page',
    enableGetEdrPointsBalanceOnLogin: 'enable-get-edr-points-balance-on-login',
    multisearch: 'multisearch',
    multisearchSf: 'multisearch-sf',
    clickAndCollectPickUpInstructions: 'click-and-collect-pick-up-instructions',
    recipeSocialMedia: 'recipe-social-media',
    recipeEmailExport: 'recipe-export-email',
    recipePrintExport: 'recipe-export-print',
    newProductsPage: 'enable-new-products-page',
    signupWithPaypal: 'enable-signup-with-paypal',
    checkoutWithPaypal: 'enable-checkout-with-paypal',
    enableInvalidURLDetection: 'enable-invalid-url-detection',
    enableCustomCouponPromotionSuccessMessage: 'enable-custom-coupon-promotion-success-message',
    enableStoreLocatorAdvancedSearch: 'enable-store-locator-advanced-search',
    showAcceptedCardsInCheckout: 'show-accepted-cards-in-checkout',
    wos4048: 'wos4048',
    enableLoadFirstCategoryLf: 'enable-load-first-category-lf',
    enableLoadFirstCategoryMf: 'enable-load-first-category-mf',
    enableMyInvoicesPage: 'enable-my-invoices-page',
    rememberMe: 'remember-me-enabled',
    enableListDataInApigee: 'enable-list-data-in-apigee',
    enableRichRelevanceRecommendations: 'enable-rich-relevance-recommendations',
    // following features are used to determine which page groups have RR placements
    // enabled. Naming convention 'rr-show-placements-in-{pagegroup}-pages' is
    // expected by the RR instrumentation components.
    rrShowPlacementsInCategoryPages: 'rr-show-placements-in-category-pages',
    rrShowPlacementsInHomepagePages: 'rr-show-placements-in-homepage-pages',
    rrShowPlacementsInHyfPages: 'rr-show-placements-in-hyf-pages',
    rrShowPlacementsInSpecialsGroupPages: 'rr-show-placements-in-specials-group-pages',

    /* STOP ADDING THINGS TO THIS, USE THE SETTINGS SERVICE! :) */
};

module.exports = FeatureService;

// Provided for backwards compat with code in Behaviour.js and Shop.js
// Delete once no longer needed
if (!('wowFeatures' in window)) {
    window.wowFeatures = new FeatureService();
}



// WEBPACK FOOTER //
// ./src/common/feature/feature.service.js